import classNames from "classnames";
import PropTypes from "prop-types";
import LinkWrap from "../../../LinkWrap/component";

import Headline from "../Headline/component";
import PrimaryContent from "./components/PrimaryContent/component";
import SecondaryContent from "./components/SecondaryContent/component";

/**
 * Card for content package items.
 *
 * @param {Object} props The component properties
 * @returns {React.Component} The CardContentPackage component
 */
const CardContentPackage = ({
    description = "",
    title = "",
    url = "",
    baseSection = "",
    subSection = "",
    className,
    flag = "",
    updateTime = null,
    headlineId = "",
    id = "",
    metadataId = null,
    external = false,
    uppercaseHeadline = false,
    packageComponents = {
        mainVisual: {
            url: "",
        },
        primary: null,
        secondary: null,
    },
    media = null,
    imageURL,
    itemType,
}) => {
    const checkFlagProp = () => {
        let newFlag = "";

        if (!flag && packageComponents?.mainContent?.typeAttributes?.flag) {
            newFlag = packageComponents.mainContent.typeAttributes.flag;
        } else if (flag) {
            newFlag = flag;
        }

        return newFlag;
    };

    const classes = classNames("card", "cardContentPackage", className);

    const linkProps = {
        "data-contentid": metadataId,
        id: metadataId,
        external: external,
        url: url,
    };

    const headlineClasses = classNames("primaryHeadlineLink", {
        uppercaseTrue: uppercaseHeadline,
    });

    const primaryProps = {
        title: title,
        deck: description,
        flag: checkFlagProp(),
        headlineId: headlineId,
        id: id,
        external: external,
        primary: packageComponents ? packageComponents.primary : null,
        baseSection: baseSection,
        subSection: subSection,
        updateTime: updateTime,
        metadataId: metadataId,
        url: url,
        imageURL: imageURL,
        headlineClasses,
        media: media,
        itemType: itemType,
    };

    return (
        <div
            className={classes}
            data-testid="card-content-package"
            data-feature-name="content-package"
        >
            <div
                className="primaryHeadline desktopHeadline"
                data-testid="primary-headline"
                data-feature-instance="primary-headline"
            >
                <LinkWrap
                    className={headlineClasses}
                    key={id}
                    data-cy="topStoriesContentPackage"
                    {...linkProps}
                >
                    <Headline id={headlineId} text={title} />
                </LinkWrap>
            </div>
            <div className="contentFlexLayout">
                <div className="firstContentColumn">
                    <PrimaryContent {...primaryProps} />
                    <SecondaryContent
                        secondary={packageComponents.secondary || []}
                    />
                </div>
            </div>
            <hr className="contentPackageSeparator" />
            <hr className="contentPackageSeparator" />
        </div>
    );
};

CardContentPackage.propTypes = {
    // The headline to display.
    title: PropTypes.string,
    // The URL that the card links to
    url: PropTypes.string,
    // ID of card
    id: PropTypes.string,
    // Is the URL external (in which case we don't handle it)?
    external: PropTypes.bool,
    className: PropTypes.string,
    // Author name and image object
    author: PropTypes.object,
    // Display comments for this card
    displayComments: PropTypes.bool,
    // story type for data-cy property
    itemType: PropTypes.string,
};

export default CardContentPackage;
